// Sesión del usuario actual. /auth/me es la fuente de verdad; React Query la cachea.
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "./api.ts";

export interface CurrentUser {
  id: string;
  orgId: string;
  firstName: string;
  lastName: string;
  email: string;
  admin: boolean;
  readOnly?: boolean;      // perfil solo-lectura (p. ej. "Consulta")
  canManageRut?: boolean;  // puede subir/reemplazar el RUT aunque sea solo-lectura
  countries?: { co: boolean; pe: boolean };  // países autorizados (segmentación)
}

export function useMe() {
  return useQuery<CurrentUser | null>({
    queryKey: ["me"],
    queryFn: async () => {
      try {
        const r = await api.get<{ user: CurrentUser }>("/auth/me");
        return r.user;
      } catch {
        return null;
      }
    },
    staleTime: 60_000,
  });
}

export function useLogin() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: { email: string; password: string }) =>
      api.post<{ user: { id: string } }>("/auth/login", body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["me"] });
    },
  });
}

export function useLogout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.post("/auth/logout"),
    onSuccess: () => {
      qc.clear();
    },
  });
}
